<template>
  <el-container class="InvoiceForm">
    <el-main class="p-0">
      <el-form
        :model="data"
        :rules="rules"
        inline
        ref="form"
        label-width="80px"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="수취일" prop="issue_date">
              <ADatePicker v-model="data.issue_date" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="금액" prop="price">
              <ANumberInput v-model="data.price" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="수취번호" prop="approval_number">
              <el-input v-model="data.approval_number" class="form-input-mid" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <ATable
        ref="table"
        :data="details"
        :height="200"
        hideButtonExcel
        hide-button-insert
        hide-pagination
      >
        <el-table-column
          prop="inbound_date"
          label="매입일자"
          :width="$width.date"
        />
        <el-table-column
          prop="product_name"
          label="품목"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="size"
          :width="$width.size"
          :label="$t('lang.size')"
        />

        <el-table-column
          prop="amount"
          label="수량"
          :width="$width.amount"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="cost"
          label="단가"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="supply_price"
          label="공급가액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="tax"
          label="세액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="금액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column prop="desc" label="비고" show-overflow-tooltip />
        <el-table-column label="삭제" width="80">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index)"
              >삭제</el-button
            >
          </template>
        </el-table-column>
      </ATable>
      <el-dialog
        custom-class="form-dialog"
        top="0"
        title="매입 가져오기"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        append-to-body
        destroyOnClose
      >
        <InboundSelect
          ref="inner"
          v-if="dialogVisible"
          :customer_id="customer.id"
          :currentItems="details"
          :type="2"
          @selceted="handleSelected"
        />
      </el-dialog>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        v-if="isNew"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ data.id > 0 ? "수정" : "등록" }}(F4)</el-button
      >
      <el-button @click="handleClickLoadInbound">매입 가져오기</el-button>
      <el-button type="danger" v-if="!isNew" @click="clickDel">삭제</el-button>

      <el-button class="right" @click="closeDialog"
        >{{ $t("button.close") }} (Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";
import InboundSelect from "./InboundSelect";

export default {
  name: "InvoiceForm",
  mixins: [form],
  components: { InboundSelect },
  data() {
    const validateValue = (rule, value, callback) => {
      // let unpublished_price = this.customer.unpublished_price ? this.customer.unpublished_price : 0;
      //
      // if (this.isNew) {
      //     if (value > unpublished_price) {
      //         callback("세금계산서 미 수취금액을 초과");
      //     }
      // } else {
      //     if (value > unpublished_price + this.data.price_old) {
      //         callback("세금계산서 미 수취금액을 초과2");
      //     }
      // }

      if (value > 2147483647) {
        callback("금액 최대값은 2147483647 입니다.");
      } else if (value < 1) {
        callback("금액은 0 보다 커야 합니다.");
      } else {
        callback();
      }
    };

    return {
      sum: 0,
      childdialogVisible: false,
      form_data: undefined,
      rules: {
        issue_date: [{ required: true, message: "수취일을 선택해 주세요." }],
        price: [
          { required: true, message: "금액을 입력해 주세요." },
          { validator: validateValue },
        ],
        // approval_number: [{required: true, message: "수취번호를 입력해 주세요."}],
      },
      details: [],
      dialogVisible: false,
    };
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      default: function() {
        return {
          id: null,
          issue_date: this.util.getDateString(),
          price: "",
          approval_number: "",
        };
      },
    },
  },
  mounted() {
    if (this.data.id) {
      this.loadInbound();
    }
  },
  computed: {
    isNew: function() {
      return this.data.id < 1;
    },
  },
  methods: {
    loadInbound() {
      this.api.listInboundBill(this.data.id).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.details = res.data;
      });
    },
    handleClickRegister() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleClickPrint() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.openDialog(this.data);
      });
    },
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;

      this.form_data = clone;
      this.childdialogVisible = true;
    },
    handleCompleted(message) {
      this.childdialogVisible = false;
      if (!message) {
        return;
      }
      this.$notify(message);
    },
    doRegister() {
      const data = this.organizeData();
      data.details = this.details;
      if (this.isNew) {
        this.api.createBill(data).then((res) => {
          if (res.error !== this.system.noError) {
            this.notifyError(res.message);
          } else {
            this.completed("create", "등록되었습니다.");
          }
        });
      } else {
        this.api.updateBill(data).then((res) => {
          if (res.error !== this.system.noError) {
            this.notifyError(res.message);
          } else {
            this.completed("update", "수정되었습니다.");
          }
        });
      }
    },
    clickDel() {
      this.util.confirm_delete(this, "세금계산서", this.doDelete);
    },
    doDelete() {
      const data = this.organizeData();
      this.api.deleteBill(data).then((res) => {
        if (res.error !== this.system.noError) {
          this.notifyError(res.message);
        } else {
          this.completed("delete", "삭제되었습니다.");
        }
      });
    },
    /** 데이터 값 정리 */
    organizeData() {
      let param = Object.assign({}, this.data);
      param.customer_id = this.customer.id;
      return param;
    },
    notifyError(message) {
      this.util.notify_error(this, "세금계산서", message);
    },
    appendItem(selection) {
      selection.forEach((item) => {
        let exist = this.details.find((d) => d.id === item.id);
        if (!exist) {
          this.details.push(item);
        }
      });
      this.setSummaryTotalPrice();
    },
    setSummaryTotalPrice() {
      let totalSupplyPrice = 0;
      let totalTax = 0;
      let totalPrice = 0;
      this.details.forEach((item) => {
        totalSupplyPrice += item.supply_price;
        totalTax += item.tax;
        totalPrice += item.price;
      });
      this.data.supply_price = totalSupplyPrice;
      this.data.tax = totalTax;
      this.data.price = totalPrice;
    },
    completed(action, message) {
      const options = this.util.get_notify_options("s", "세금계산서", message);
      this.$emit("completed", action, options);
    },
    handleClickLoadInbound() {
      this.dialogVisible = true;
    },
    handleSelected(selection) {
      this.appendItem(selection);
      this.dialogVisible = false;
    },
    handleDelete(index /*, row*/) {
      this.details.splice(index, 1);
      this.setSummaryTotalPrice();
    },
  },
};
</script>
